import LoginService from '../../data/LoginService';

const getToken = () => LoginService.getToken();

export default getToken;
